const config = require('./seo.json');

function getPageSeo(pathname = '/') {
  const path = pathname.split(/[?#]/)[0].replace(/\/+$/, '') || '/';
  const page = config.pages[path];
  const admin = path === '/admin' || path.startsWith('/admin/');
  return {
    title: admin ? `Admin Portal | ${config.siteName}` : page ? page.title || config.title : `Page Not Found | ${config.siteName}`,
    description: page?.description || config.description,
    keywords: config.keywords,
    canonical: `${config.siteUrl}${path === '/' ? '/' : path}`,
    image: new URL(config.image, config.siteUrl).href,
    noindex: admin || !page || Boolean(page.noindex),
  };
}

function getBusinessSchema() {
  const { business } = config;
  return {
    '@context': 'https://schema.org',
    '@type': ['LocalBusiness', 'EducationalOrganization'],
    '@id': `${config.siteUrl}/#academy`,
    name: config.siteName,
    url: `${config.siteUrl}/`,
    description: config.description,
    image: new URL(config.image, config.siteUrl).href,
    logo: new URL(config.image, config.siteUrl).href,
    telephone: business.telephone,
    email: business.email,
    address: {
      '@type': 'PostalAddress',
      addressLocality: business.addressLocality,
      addressRegion: business.addressRegion,
      addressCountry: business.addressCountry,
    },
    sameAs: business.sameAs,
  };
}

module.exports = { getPageSeo, getBusinessSchema };
